export default "__VITE_ASSET__DEmgBhM$__"